<div class="d-flex justify-content-center py-4">
    <div class="col-lg-3 col-md-4 col-sm-6 col-11 login-form mt-5 shadow">
        <div class="d-flex justify-content-center">
            <img src="../../../assets/Img/fleetYar_logo.png" class="logo mt-4 mb-3">
        </div>
        <hr class="hr1">
        <p class="text-center f18 text-secondary mb-1 d-none">{{webAppName}}</p>
        <p class="text-center bold" dir="rtl" id="lblBuyer"
            style="color:Blue;font-family:inherit;font-size:14pt;font-weight:normal;">{{appName}}</p>

        <div class="col-9 mt-1 mx-auto" [formGroup]="RegisterModel" *ngIf="!otp">
            <div class="input-group mb-2 ">

                <input class="form-control bg-gray  text-start radios-left" formControlName="strUserName" type="tel"
                    placeholder="شماره موبایل" value="">
                <span class="input-group-text bg-gray radios-right">
                    <i class="fa fa-mobile-phone " style="cursor: pointer"></i>
                </span>
            </div>
            <div class="input-group mb-2 ">

                <input class="form-control bg-gray  text-start radios-left" formControlName="strFullName" type="text"
                    placeholder="نام کامل" value="">
                <span class="input-group-text bg-gray radios-right">
                    <i class="fa fa-user-o " style="cursor: pointer"></i>
                </span>
            </div>
            <div class="input-group mb-2  ">

                <input class="form-control bg-gray  text-start radios-left" formControlName="strPassword" id="password"
                    placeholder="رمز عبور مد نظر" [type]="password ? 'text' : 'password'">
                <span class="input-group-text bg-gray radios-right" (click)="changeType()">
                    <i class="fa fa-eye-slash " *ngIf="!password" style="cursor: pointer"></i>
                    <i class="fa fa-eye " *ngIf="password" style="cursor: pointer"></i>
                </span>
            </div>
            <div class="input-group mb-2  ">

                <input class="form-control bg-gray  text-start radios-left" formControlName="strPassword2"
                    placeholder="تکرار رمز عبور مد نظر" [type]="password2 ? 'text' : 'password'">
                <span class="input-group-text bg-gray radios-right" (click)="changeType2()">
                    <i class="fa fa-eye-slash " *ngIf="!password2" style="cursor: pointer"></i>
                    <i class="fa fa-eye " *ngIf="password2" style="cursor: pointer"></i>
                </span>
            </div>
            <div class="input-group mb-3 ">

                <input class="form-control bg-gray  text-start radios-left" type="tel"
                    formControlName="strIntroducedMobile" placeholder="شماره موبایل معرف" value="">
                <span class="input-group-text bg-gray radios-right">
                    <i class="fa fa-mobile-phone " style="cursor: pointer"></i>
                </span>
            </div>
        </div>
        <div class="col-9 mt-5 mx-auto" [formGroup]="OtpModel" *ngIf="otp">

            <div class="input-group mb-3 ">

                <input class="form-control bg-gray  text-start radios-left" type="tel" formControlName="iOTP"
                    placeholder="کد دریافتی" value="">
                <span class="input-group-text bg-gray radios-right">
                    <i class="fa fa-codepen " style="cursor: pointer"></i>
                </span>
            </div>
            <p class="text-center m-0 pointer" (click)="createOtp(true)" *ngIf="!repet">ارسال مجدد کد</p>
            <!-- <button (click)='startTimer()'>Start Timer</button>
              <button (click)='pauseTimer()'>Pause</button> -->

            <p *ngIf="repet" class="text-center">{{timeLeft}} </p>




        </div>
        <div class=" d-flex align-items-center mt-3 flex-column mb-2">
            <button class="btn btn-success d-flex col-9 align-items-center  justify-content-center mb-3" *ngIf="!otp"
                (click)="register()"><span>ثبت نام در سامانه</span> <i class="fa fa-user-circle px-2"></i></button>


        </div>
        <div class=" d-flex align-items-center mt-1 flex-column mb-2" *ngIf="otp">
            <button class="btn btn-success d-flex col-9 align-items-center  justify-content-center mb-3"
                (click)="chekOtp()"><span>بررسی کد</span> <i class="fa fa-check-circle px-2"></i></button>


        </div>

    </div>

</div>